export default {"src":"/_next/static/media/dark-mode-icon-collapsed.b846d8d1.svg","height":1376,"width":1316,"blurWidth":0,"blurHeight":0};